import type { BrowseMarket } from '@/api/cmApi'
import { isBetradarFromId } from './catalogMarkets'
import { defaultMaxLimitsType } from './fancyLimitsType'

export type MaxBetForm = {
  maxBet: string
  maxMarket: string
  maxBetFancy: string
  maxMarketFancy: string
  maxLimitsType: string
  marketInPlayAt: string
  videoUrl: string
  channelId: string
  betradarId: string
  statsId: string
}

export function toLocalInput(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function fromLocalInput(local: string): string | null {
  if (!local.trim()) return null
  const d = new Date(local)
  return Number.isNaN(d.getTime()) ? null : d.toISOString()
}

export function formFromMarket(m: BrowseMarket): MaxBetForm {
  return {
    maxBet: m.maxBet != null ? String(m.maxBet) : '',
    maxMarket: m.maxMarket != null ? String(m.maxMarket) : '',
    maxBetFancy: m.maxBetFancy != null ? String(m.maxBetFancy) : '',
    maxMarketFancy: m.maxMarketFancy != null ? String(m.maxMarketFancy) : '',
    maxLimitsType: defaultMaxLimitsType(m.maxLimitsType),
    marketInPlayAt: toLocalInput(m.marketInPlayAt),
    videoUrl: m.videoUrl ?? '',
    channelId: m.channelId ?? '',
    betradarId: m.betradarId ?? '',
    statsId: m.statsId ?? '',
  }
}

/** After Market on, CM Event toggle must show On (API opens parent event). */
export function hitsWithEventOnAfterMarketEnable<
  T extends { vendorEventId: string; enabled: boolean },
>(hits: T[], vendorEventId: string, marketEnabled: boolean): T[] {
  if (!marketEnabled) return hits
  return hits.map((e) =>
    e.vendorEventId === vendorEventId ? { ...e, enabled: true } : e,
  )
}

/** Match Odds `POST /v1/catalog/market/update` body (Betradar + Stats id). */
export function matchOddsMarketUpdatePayload(
  form: MaxBetForm,
  vendor: string,
  vendorMarketId: string,
): Record<string, unknown> {
  const betradarId = form.betradarId.trim() || null
  const statsId = form.statsId.trim() || null
  return {
    vendor,
    vendorMarketId,
    videoUrl: form.videoUrl.trim() || null,
    channelId: form.channelId.trim() || null,
    betradarId,
    isBetradar: isBetradarFromId(betradarId),
    statsId,
    marketInPlayAt: fromLocalInput(form.marketInPlayAt),
  }
}
